/** Puestos que no pueden ver ni operar la nomina administrativa (solo teachers / propia). */
export const PUESTOS_SIN_NOMINA_ADMIN = [40, 52, 82] // 40 Jefe op., 52 Programador producto, 82

/** Puestos con acceso forzado al menu de Nomina Semanal (Teachers, sin montos). */
export const PUESTOS_MENU_NOMINA_SEMANAL = [40, 52] // Jefe de operaciones, Programador de producto

/** Puestos que ven Teachers pero sin campos de dinero. */
export const PUESTOS_NOMINA_SIN_CANTIDADES = [40, 52]

/**
 * Iderps tratados como Jefe de operaciones aunque el idpuesto en sesion varie.
 * 568 = Maria Esther Segura (JEFE DE OPERACIONES en UI).
 */
export const IDERPS_JEFE_OPERACIONES_NOMINA = [568]

/**
 * Programador de producto que sí ve montos en la nómina de teachers.
 * 169 es la única excepción del puesto 52.
 */
export const IDERPS_PROGRAMADOR_VE_MONTOS = [169]

/** Values de columnas/headers que representan dinero. */
const VALUES_DINERO_NOMINA = [
  'PAGO_SABADO',
  'PAGO_DOBLES_SABADO',
  'PAGO_SABADO_TOTAL',
  'pago_quincena',
  'bono_teacher',
  'PAGO_DOBLES',
  'REBAJES',
  'DESC_HUELLA_SAB',
  'DESC_HUELLA_QUIN',
  'PAGO_TOTAL',
  'bono_anterior',
  'costo',
  'valor_hora',
  'categoria',
  'categoria_lv',
  'categoria_d',
  'costo_unitario',
  'costo_total',
  'monto',
]

function idPuesto (usuario) {
  return usuario && usuario.idpuesto != null ? Number(usuario.idpuesto) : null
}

function idErp (usuario) {
  return usuario && usuario.iderp != null ? Number(usuario.iderp) : null
}

function esIderpJefeOperaciones (usuario) {
  return IDERPS_JEFE_OPERACIONES_NOMINA.indexOf(idErp(usuario)) !== -1
}

function esProgramadorVeMontos (usuario) {
  return IDERPS_PROGRAMADOR_VE_MONTOS.indexOf(idErp(usuario)) !== -1
}

export function puedeVerNominaAdministrativa (usuario) {
  if (!usuario || usuario.idpuesto == null) {
    if (esIderpJefeOperaciones(usuario)) return false
    return true
  }
  if (esIderpJefeOperaciones(usuario)) return false
  return !PUESTOS_SIN_NOMINA_ADMIN.includes(idPuesto(usuario))
}

export function esNominaSinCantidades (usuario) {
  if (!usuario) return false
  if (esProgramadorVeMontos(usuario)) return false
  if (esIderpJefeOperaciones(usuario)) return true
  if (usuario.idpuesto == null) return false
  return PUESTOS_NOMINA_SIN_CANTIDADES.includes(idPuesto(usuario))
}

export function puedeSubirRequisicionNomina (usuario) {
  if (!usuario) return false
  if (esIderpJefeOperaciones(usuario)) return false
  if (idPuesto(usuario) == null) return true
  return !PUESTOS_NOMINA_SIN_CANTIDADES.includes(idPuesto(usuario))
}

export function puedeVerMenuNominaSemanal (usuario) {
  if (!usuario) return false
  if (esIderpJefeOperaciones(usuario)) return true
  if (usuario.idpuesto == null) return false
  return PUESTOS_MENU_NOMINA_SEMANAL.includes(idPuesto(usuario))
}

/**
 * Detecta si un header de tabla es de dinero.
 * `diferencia` en "Horas por grupo" (text Cambio) NO es dinero.
 */
export function esCampoDineroNomina (header) {
  if (!header || header.value == null) return false
  const value = String(header.value)
  if (VALUES_DINERO_NOMINA.indexOf(value) !== -1) return true
  if (value === 'diferencia') {
    const text = String(header.text || '').toLowerCase()
    return text.indexOf('cambi') === -1
  }
  return false
}

export function filtrarHeadersSinDinero (headers) {
  if (!Array.isArray(headers)) return []
  return headers.filter(function (h) { return !esCampoDineroNomina(h) })
}

function menuTienePath (menu, path) {
  if (!Array.isArray(menu)) return false
  for (var i = 0; i < menu.length; i++) {
    var top = menu[i]
    if (top && top.path === path) return true
    if (top && top.items && menuTienePath(top.items, path)) return true
  }
  return false
}

/**
 * Inyecta Nomina Semanal en el menu lateral para puestos 40/52 e iderp 568
 * si el API de permisos no la trajo.
 */
export function asegurarMenuNominaSemanal (menu, usuario) {
  var list = Array.isArray(menu) ? menu.slice() : []
  if (!puedeVerMenuNominaSemanal(usuario)) return list
  if (menuTienePath(list, 'Nomina') || menuTienePath(list, 'nomina')) return list

  var item = {
    title: 'N\u00f3mina Semanal',
    path: 'Nomina',
    icon: 'mdi-cash-multiple',
    color: null,
    active: 0,
  }

  var norm = function (t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }

  var rh = null
  for (var i = 0; i < list.length; i++) {
    var t = norm(list[i] && list[i].title)
    // Match exacto RH / Recursos humanos (evitar falsos positivos con indexOf('rh'))
    if (t === 'rh' || t.indexOf('recurso') !== -1) {
      rh = list[i]
      break
    }
  }

  if (!rh) {
    rh = {
      title: 'RH',
      action: 'mdi-briefcase-account',
      active: false,
      items: [],
    }
    list.push(rh)
  }

  // Clonar nodo RH para que Vue detecte el cambio
  var rhItems = Array.isArray(rh.items) ? rh.items.slice() : []

  // Si RH solo tiene subgrupos (cat.items), meter Nomina dentro del primer subgrupo con items
  var subConItems = null
  for (var j = 0; j < rhItems.length; j++) {
    if (rhItems[j] && Array.isArray(rhItems[j].items) && rhItems[j].items.length) {
      subConItems = rhItems[j]
      break
    }
  }

  if (subConItems) {
    var subItems = subConItems.items.slice()
    subItems.push(item)
    var nuevoSub = Object.assign({}, subConItems, { items: subItems })
    rhItems = rhItems.map(function (el) {
      return el === subConItems ? nuevoSub : el
    })
  } else {
    rhItems.push(item)
  }

  var rhIndex = list.indexOf(rh)
  var rhNuevo = Object.assign({}, rh, { items: rhItems })
  if (rhIndex >= 0) {
    list.splice(rhIndex, 1, rhNuevo)
  } else {
    list.push(rhNuevo)
  }

  return list
}
